import React from "react";
import { useSelector } from "react-redux";
import AgencyProjects from "./agency";
import FreelancerProjects from "./freelancer";

function ProjectsPage() {
  const user = useSelector((state) => state.user || {});
  const isAgency = user?.isAgency ?? false;
  return <>{isAgency ? <AgencyProjects /> : <FreelancerProjects />}</>;
}

export default ProjectsPage;
